import React, { Component, PropTypes } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import axaTheme from './themes/axa/axa-theme';

export default class MaterialThemeProvider extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  render() {
    const muiThemeFormatted = getMuiTheme(axaTheme);

    return <MuiThemeProvider muiTheme={muiThemeFormatted}>
      {this.props.children}
    </MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/app/MaterialThemeProvider.js